import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {updateTitle} from '../../actions/updateTitle'


function Title({text, updateTitle}) {
    return(
        <div className="form-group">
            <label htmlFor="title">Title</label>
            <input type="text" className="form-control" id="title" value={text}
                   onChange={(event) => updateTitle(event.target.value)} required />
        </div>
    );
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({updateTitle}, dispatch);
}

export default connect(null, mapDispatchToProps)(Title);




// WEBPACK FOOTER //
// ./src/admin/components/editor/containers/header/Title.js